<div class="rendition-finish-movements-container">
    <div class="msg-success">
      <div class="icon-container">
        <qr-icon [name]="ICON_DONE" [color]="ICON_COLOR_WHITE"></qr-icon>
      </div>
      <p>{{value}}</p>
    </div>
    <div class="buttons">
      <qr-button
          class="print"
          [config]="buttonPrint"
          (click)="onAction(0)"
        ></qr-button>
        <qr-button
          class="go-panel-rendition"
          [config]="buttonGoPanel"
          (click)="onAction(1)"
        ></qr-button>
    </div>
  </div>